
  <router-outlet  (activate)="onActivate($event)">
    <div id="success-snackbar"></div>
    <div id="error-snackbar"></div>
  </router-outlet>
